import { Link } from "react-router-dom";
import Navbar from "../components/feature/Navbar";
import Footer from "../components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center bg-white">
        <div className="text-center px-6">
          <div className="w-20 h-20 bg-[#E3F2FD] rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="w-10 h-10 flex items-center justify-center text-[#4A90D9]">
              <i className="ri-error-warning-line text-3xl"></i>
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            404
          </h1>
          <p className="text-lg text-gray-500 mb-8">
            The page you are looking for does not exist.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#4A90D9] hover:bg-[#3A7BC8] text-white text-sm font-semibold px-7 py-3.5 rounded-full transition-colors whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base"></i>
            </span>
            Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
